import { px } from '@adsk/alloy-react-helpers';

import {
  AlloyLegacyThemeDesignTokens,
  CommentFieldDesignTokens,
} from '../types';
import { WeaveTheme } from '../types/weaveTypes';

type WeaveTokens = NonNullable<WeaveTheme['tokens']>;

/** Size of the inline error icon, shared by both themes */
const ERROR_ICON_SIZE = 16;

export const getCommentFieldTokensAlloy = (
  theme: AlloyLegacyThemeDesignTokens,
): CommentFieldDesignTokens => {
  const { typography, spacing } = theme;
  const { colors } = theme.tokens;
  const countPaddingBlock = px(spacing.XS);
  const countPaddingInline = px(spacing.S);

  return {
    inputContainer: {
      'margin-left': px(14),
    },
    input: {
      color: colors.text.primary.value,
      'min-height': px(68),
    },
    actions: {
      'margin-top': px(10),
    },
    error: {
      container: {
        'margin-top': px(5),
      },
      text: {
        color: colors.text.error.value,
        'font-family': typography.bodySmall.fontFamily,
        'font-size': typography.bodySmall.fontSize,
        'font-weight': typography.bodySmall.fontWeight,
        'line-height': typography.bodySmall.lineHeight,
      },
      icon: {
        color: colors.icon.error.value,
        'margin-right': px(spacing.XS),
        'icon-size': ERROR_ICON_SIZE,
      },
    },
    cancelButton: {
      'margin-right': px(spacing.S),
    },
    characterCount: {
      _: {
        color: colors.text.secondary.value,
        'font-family': typography.labelSmall.fontFamily,
        'font-size': typography.labelSmall.fontSize,
        'font-weight': typography.labelSmall.fontWeight,
        'line-height': typography.labelSmall.lineHeight,
        'padding-top': countPaddingBlock,
        'padding-right': countPaddingInline,
        'padding-bottom': countPaddingBlock,
        'padding-left': countPaddingInline,
      },
      overflow: {
        color: colors.text.error.value,
      },
    },
    counterInput: {
      'padding-bottom': px(36),
    },
  };
};

export const getCommentFieldTokensWeave = (
  tokens: WeaveTokens,
  fontFamily: string,
): CommentFieldDesignTokens => {
  const semantic = tokens?.semantic;
  const generic = tokens?.generic;
  const typography = tokens?.component?.typography;

  const spacing4 = generic?.spacing?.[4];
  const spacing8 = generic?.spacing?.[8];
  const spacing16 = generic?.spacing?.[16];
  const errorColor = semantic?.['status-color']?.error;
  const captionFontSize = typography?.caption?.['font-size'];
  const captionLineHeight = typography?.caption?.['line-height'];
  const regularFontWeight = typography?.regular?.['font-weight'];

  return {
    inputContainer: {
      'margin-left': spacing16,
    },
    input: {
      color: semantic?.['text-color']?.medium?.default,
      'min-height': generic?.spacing?.[68],
    },
    actions: {
      'margin-top': spacing8,
    },
    error: {
      container: {
        'margin-top': spacing4,
      },
      text: {
        color: errorColor,
        'font-family': fontFamily,
        'font-size': captionFontSize,
        'font-weight': regularFontWeight,
        'line-height': captionLineHeight,
      },
      icon: {
        color: errorColor,
        'margin-right': spacing4,
        'icon-size': ERROR_ICON_SIZE,
      },
    },
    cancelButton: {
      'margin-right': spacing8,
    },
    characterCount: {
      _: {
        color: semantic?.['text-color']?.light,
        'font-family': fontFamily,
        'font-size': captionFontSize,
        'font-weight': regularFontWeight,
        'line-height': captionLineHeight,
        'padding-top': spacing4,
        'padding-right': spacing8,
        'padding-bottom': spacing4,
        'padding-left': spacing8,
      },
      overflow: {
        color: errorColor,
      },
    },
    counterInput: {
      'padding-bottom': generic?.spacing?.[36],
    },
  };
};
